module.exports = __webpack_public_path__ + "img/new_age_02.fd8d9692.jpg";